<div class="pie-pagina text-center pb-1 ">
  <p class=" pt-2 text-white">&copy; 2020 Asociación Hogar Jesus Amigo. <br> Todos los derechos reservados <br>
    Pagina desarrollada con <i class="fas fa-heart icono"></i> por G.A.R.M</p>
</div>
